import React from 'react'


import Grid from '@material-ui/core/Grid'
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

import TextField from '@material-ui/core/TextField'
import StripeInput from './StripeInput'


import CreditCard from '@material-ui/icons/CreditCard';
import Typography from '@material-ui/core/Typography';

//https://gist.github.com/lfalke/1c5e7168424c8b2a65dcfba425fcc310
//https://github.com/stripe/react-stripe-elements/issues/164


export default function StripeCardSection() {
  console.log(CardNumberElement)
  return (
    <Grid container >
      <Grid item xs={12}>
        <Grid container spacing={4} alignItems="flex-end">
          <Grid item xs={1}>
            <CreditCard style={{ marginTop: 6 }} />
          </Grid>
          <Grid item xs={11}>
            <Typography variant="h6" > Payment information</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Credit Card Number"
              name="ccnumber"
              required
              fullWidth
              InputProps={{
                inputComponent: StripeInput,
                inputProps: {
                  component: CardNumberElement
                },
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={8}>
            <TextField
              label="Expiration Date"
              name="ccexp"
              required
              fullWidth
              InputProps={{
                inputProps: {
                  component: CardExpiryElement
                },
                inputComponent: StripeInput
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="CVC"
              name="cvc"
              required
              fullWidth
              InputProps={{
                inputProps: {
                  component: CardCvcElement
                },
                inputComponent: StripeInput
              }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </Grid>





    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/StripeCardSection.js